import React from 'react';
import { Route,Routes} from 'react-router-dom';
import Home from '../Pages/Home.jsx';
import Services from "../Pages/Services";
import Blog from "../Pages/Blog";
import Mobile from "../Pages/GreenServices/MobileApp";
import YellowService from "../Pages/yellowServices/Yellow1";
import About from "../Pages/About";
import Contact from "../Pages/Contact";
import RedTeam from "../Pages/redServices/RedTeam";
import Penetration from "../Pages/redServices/Penetration";
import Vulnerability from "../Pages/redServices/vulnerability";
import CodeReview from "../Pages/redServices/SourceReview";
import GRC from "../Pages/yellowServices/GRC";
import SOC from "../Pages/yellowServices/SOC";
import ManageBug from "../Pages/yellowServices/ManageBug";
import Resellers from "../Pages/Resellers";
import Tech from "../Pages/Tech";
import FAQs from "../Pages/FAQs";
import WhiteHawk from "../Pages/WhiteHawk";


function Paths() {
  return (
    <Routes>
      {/* public routes  */}
        <Route exact path="/" element={<Home />}/>
        <Route exact path="/services" element={<Services />}/>
        <Route exact path="/services/vulnerability" element={<Vulnerability />}/>
        <Route exact path="/services/code-review" element={<CodeReview />}/>
        <Route exact path="/services/red-team" element={<RedTeam/>}/>
        <Route exact path="/services/penetration" element={<Penetration/>}/>
        <Route exact path="/blog" element={<Blog/>}/>
        <Route exact path="/services/mobile" element={<Mobile/>}/>
        <Route exact path="/services/grc" element={<GRC/>}/>
        <Route exact path="/services/soc" element={<SOC/>}/>
        <Route exact path="/services/manage-bug" element={<ManageBug/>}/>
        <Route exact path="/about" element={<About/>}/>
        <Route exact path="/contact" element={<Contact/>}/>
          <Route exact path="/resellers-partners" element={<Resellers/>}/>
        <Route exact path="/tech-partners" element={<Tech/>}/>
        <Route exact path="/FAQs" element={<FAQs/>}/>
        <Route exact path="/white-hawk" element={<WhiteHawk/>}/>


      </Routes>
  )
}

export default Paths